import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
// import { initOneSignal } from "./push/onesignal";
import { supabase } from "./integrations/supabase/client";
import { registerSW } from "virtual:pwa-register";
import { initRuntimeMonitoring, logAppError } from "./lib/appLogger";
import { initNativePushNotifications, syncStoredPushToken } from "./lib/pushNotifications";

// initOneSignal(); //
initRuntimeMonitoring();
initNativePushNotifications();

window.addEventListener("error", (event) => {
  logAppError("window_error", event.error ?? event.message, {
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  logAppError("unhandled_promise_rejection", event.reason);
});

registerSW({
  immediate: true,
  onOfflineReady() {
    console.info("[PWA] offline shell ready");
  },
  onNeedRefresh() {
    console.info("[PWA] new version available");
  },
  onRegisterError(error) {
    logAppError("service_worker_register_failed", error);
  },
});

// Intercept PASSWORD_RECOVERY event BEFORE any component mounts.
// This sets a sessionStorage flag that all shell auth guards check,
// preventing them from redirecting the user to their dashboard while
// they should be redirected to /reset-password instead.
supabase.auth.onAuthStateChange((_event, session) => {
  if (session) {
    void syncStoredPushToken();
  }
  if (_event === "PASSWORD_RECOVERY") {
    sessionStorage.setItem("password_recovery_pending", "1");
  }
});

// MEDIUM FIX: Android hardware back button handling via Capacitor
// Prevents accidental app exit during live booking/payment flows.
const setupAndroidBackButton = async () => {
  try {
    const moduleName = "@capacitor/app";
    const { App: CapacitorApp } = await import(/* @vite-ignore */ moduleName);
    CapacitorApp.addListener('backButton', ({ canGoBack }) => {
      // Block back during sensitive booking flows
      const pathname = window.location.pathname;
      const protectedPaths = ['/c/booking-flow', '/booking-flow', '/hire-contract'];
      const isProtectedFlow = protectedPaths.some(p => pathname.startsWith(p));
      
      if (isProtectedFlow) {
        return;
      }

      if (canGoBack) {
        window.history.back();
      } else {
        CapacitorApp.exitApp();
      }
    });
  } catch {
    // Not running in Capacitor — silently ignore
  }
};

setupAndroidBackButton();

createRoot(document.getElementById("root")!).render(
  React.createElement(App)
);
